import * as events from '~/plugins/mixpanel/events'
import * as props from '~/plugins/mixpanel/props'

export const associations: { [key: string]: string[] } = {
  [events.UPGRADE_PRO_MODAL_VIEW]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT,
    props.FREEMIUM_LIMITED,
    props.PRO_MODAL_NEW,
    props.FREEMIUM_CREDIBILITY,
    props.FREEMIUM_STATUSES,
    props.SIMILAR_CARD
  ],
  [events.PRO_CHANCES_CLICK]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT,
    props.PRO_MODAL_NEW,
    props.FREEMIUM_CREDIBILITY
  ],
  [events.UPGRADE_PRO_PLAN_CLICK]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT,
    props.PRO_MODAL_NEW,
    props.FREEMIUM_CREDIBILITY,
    props.FREEMIUM_STATUSES
  ],
  [events.CHANGE_TAB]: [
    props.TAB_NAME
  ],
  [events.TOOLTIP_VIEW]: [
    props.TAB_NAME,
    props.OPENED_FROM,
    props.FREEMIUM_STATUSES
  ],
  [events.UNLOCK_PRO_BUTTON_CLICK_TOOLTIP]: [
    props.TAB_NAME,
    props.OPENED_FROM,
    props.PRO_MODAL_NEW
  ],
  [events.COMPLETE_APPLICATION_BUTTON_CLICK_STARTED_APPLICATIONS]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.IS_EASY
  ],
  [events.APPLY_FOR_SCHOLARSHIP_BUTTON_CLICK_STARTED_APPLICATIONS]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.IS_EASY
  ],
  [events.EDIT_APPLICATION_BUTTON_CLICK_STARTED_APPLICATIONS]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.IS_EASY
  ],
  [events.CLAIM_AWARD_BUTTON_CLICK_SUBMITTED_APPLICATIONS]: [
    props.SCHOLARSHIP_ID,
    props.CLICKED_FROM,
    props.MAINTENANCE_MODE
  ],
  [events.APPLICATION_PREVIEW_REQ_DOWNLOAD]: [
    props.REQUIREMENT_TYPE
  ],
  [events.APPLICATION_PREVIEW_REQ_VIEW]: [
    props.REQUIREMENT_TYPE
  ],
  [events.CATEGORY_FILTER_APPLIED]: [
    props.SELECTED_CATEGORIES,
    props.MAINTENANCE_MODE
  ],
  [events.SEARCH_APPLIED]: [
    props.ENTERED_VALUE,
    props.TAB_NAME,
    props.MAINTENANCE_MODE
  ],
  [events.SCHOLARSHIP_CARD_IGNORE]: [
    props.SCHOLARSHIP_ID,
    props.SCHOLARSHIP_TYPE,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.IS_EASY,
    props.FREEMIUM_CREDIBILITY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD
  ],
  [events.SCHOLARSHIP_CARD_UNIGNORE]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_TYPE,
    props.IS_EASY,
    props.CREDIBILITY_SCORE
  ],
  [events.SCHOLARSHIP_CARD_REPORT]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_TYPE,
    props.MAINTENANCE_MODE,
    props.IS_EASY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD
  ],
  [events.SCHOLARSHIP_CARD_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_TYPE,
    props.MAINTENANCE_MODE,
    props.IS_EASY,
    props.FREEMIUM_LIMITED,
    props.FREEMIUM_CREDIBILITY,
    props.CREDIBILITY_SCORE,
    props.FREEMIUM_STATUSES,
    props.SIMILAR_CARD
  ],
  [events.SCHOLARSHIP_DETAILS_VIEW]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.SCHOLARSHIP_TYPE,
    props.IS_SEEN,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.PAYOUT_METHOD,
    props.MAINTENANCE_MODE,
    props.IS_EASY,
    props.FREEMIUM_CREDIBILITY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD
  ],
  [events.SCHOLARSHIP_CARD_PICK]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_TYPE,
    props.MAINTENANCE_MODE,
    props.IS_EASY,
    props.FREEMIUM_CREDIBILITY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD
  ],
  [events.SCHOLARSHIP_CARD_UNPICK]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_TYPE,
    props.MAINTENANCE_MODE,
    props.IS_EASY,
    props.CREDIBILITY_SCORE
  ],
  [events.APPLICATION_REVIEW_SCREEN_VIEW]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_TYPE,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.TAB_NAME,
    props.PAYOUT_METHOD,
    props.IS_EASY,
    props.FREEMIUM_CREDIBILITY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD
  ],
  [events.SUBMITTED_APPLICATION_DETAILS_VIEW]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.SCHOLARSHIP_AMOUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.DERIVED_STATUS,
    props.MAINTENANCE_MODE,
    props.FREEMIUM_STATUSES
  ],
  [events.DOWNLOAD_SUBMITTED_REQUIREMENT]: [
    props.REQUIREMENT_TYPE,
    props.MAINTENANCE_MODE
  ],
  [events.VIEW_SUBMITTED_REQUIREMENT]: [
    props.REQUIREMENT_TYPE,
    props.MAINTENANCE_MODE
  ],
  [events.VISIT_SUBMITTED_LINK_BUTTON]: [
    props.REQUIREMENT_TYPE,
    props.MAINTENANCE_MODE
  ],
  [events.PAYOUT_TOOLTIP_VIEW]: [
    props.TAB_NAME,
    props.SCHOLARSHIP_ID,
    props.PAYOUT_METHOD
  ],
  [events.REQUIREMENT_WRITE]: [
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_TYPE,
    props.TAB_NAME,
    props.IS_OPTIONAL,
    props.SCHOLARSHIP_CATEGORY
  ],
  [events.APPLICATION_STARTED]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.IS_EASY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD,
    props.HEALTH_BAR_FEATURE_FLAG
  ],
  [events.REQUIREMENT_COMPLETED]: [
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_TYPE,
    props.IS_OPTIONAL,
    props.TAB_NAME
  ],
  [events.REQUIREMENT_UPLOADED]: [
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_TYPE,
    props.IS_OPTIONAL,
    props.TAB_NAME,
    props.SCHOLARSHIP_CATEGORY,
    props.VIDEO_RECORDER
  ],
  [events.SIMILAR_SCHOLARSHIPS_BUTTON_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.IS_EASY,
    props.SIMILAR_CARD
  ],
  [events.SAVE_SIMILAR_SCHOLARSHIP_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_SEEN,
    props.TAB_NAME,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_TYPE,
    props.IS_EASY,
    props.SIMILAR_CARD
  ],
  [events.TAB_CHANGE]: [
    props.TAB_NAME,
    props.MAINTENANCE_MODE,
    props.FREEMIUM_STATUSES,
    props.SIMILAR_CARD
  ],
  [events.APPLICATION_SENT]: [
    props.SCHOLARSHIP_TYPE,
    props.TAB_NAME,
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_POINTS,
    props.TOTAL_USER_POINTS,
    props.PAYOUT_METHOD,
    props.SCHOLARSHIP_CATEGORY,
    props.IS_SIMILAR,
    props.IS_EASY,
    props.FREEMIUM_CREDIBILITY,
    props.CREDIBILITY_SCORE,
    props.SIMILAR_CARD,
    props.HEALTH_BAR_FEATURE_FLAG
  ],
  [events.UNLOCK_STATUSES_CLICK]: [
    props.TAB_NAME,
    props.PRO_MODAL_NEW
  ],
  [events.UNLOCK_PRO_RECOMMENDED_CLICK]: [
    props.TAB_NAME,
    props.PRO_MODAL_NEW
  ],
  [events.UNLOCK_AUTOMATIC_CLICK]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT,
    props.PRO_MODAL_NEW
  ],
  [events.UNLOCK_PRO_BUTTON_CLICK_NAVIGATION]: [
    props.TAB_NAME,
    props.FREEMIUM_LIMITED,
    props.PRO_MODAL_NEW,
    props.FREEMIUM_CREDIBILITY,
    props.SIMILAR_CARD
  ],
  [events.PACKAGE_BUTTON_CLICK]: [
    props.PAYMENT_PACKAGE_ID,
    props.PAYMENT_PACKAGE_NAME,
    props.PAYMENT_PACKAGE_PRICE,
    props.PRO_MODAL_NEW
  ],
  [events.PAYMENT_REDIRECT]: [
  ],
  [events.PAYMENT_MODAL_OPEN]: [
    props.PRO_MODAL_NEW
  ],
  [events.PAYMENT_MODAL_CLOSE]: [
    props.PRO_MODAL_NEW
  ],
  [events.REACTIVATE_PRO_PLAN_CLICK]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT
  ],
  [events.REACTIVATE_PRO_BUTTON_CLICK_NAVIGATION]: [
    props.TAB_NAME
  ],
  [events.REACTIVATE_PRO_RECOMMENDED_CLICK]: [
    props.TAB_NAME
  ],
  [events.TOOLTIP_VIEW_MAINTENANCE_MODE]: [
    props.TAB_NAME,
    props.OPENED_FROM
  ],
  [events.REACTIVATE_PRO_BUTTON_CLICK_DETAILS]: [
    props.TAB_NAME,
    props.OPENED_FROM,
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_COUNT
  ],
  [events.REACTIVATE_PRO_MODAL_VIEW]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT
  ],
  [events.NO_ENGAGEMENT_SURVEY_BTN_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.CONFIDENCE_SCORE,
    props.REQUIREMENT_COUNT,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.SCHOLARSHIP_AMOUNT,
    props.SCHOLARSHIP_TYPE,
    props.IS_SEEN,
    props.IS_RECOMMENDED,
    props.IS_SIMILAR,
    props.REQUIREMENT_TYPE,
    props.AWARD_COUNT,
    props.SCHOLARSHIP_CATEGORY,
    props.SCHOLARSHIP_POINTS,
    props.PAYOUT_METHOD,
    props.MAINTENANCE_MODE,
    props.IS_EASY
  ],
  [events.COMPLETE_GOAL_REQUIREMENT_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_TYPE,
    props.IS_OPTIONAL,
    props.TAB_NAME
  ],
  [events.VERIFY_GOAL_REQUIREMENT_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_TYPE,
    props.IS_OPTIONAL,
    props.TAB_NAME
  ],
  [events.FREEMIUM_RECOMMENDER_UNLOCK_PRO_BUTTON_CLICK]: [
    props.PRO_MODAL_NEW
  ],
  [events.GO_BACK_TO_BROWSING_MATCHES]: [],
  [events.SIMILARITY_SCREEN_VIEW]: [
    props.TAB_NAME,
    props.REQUIREMENT_COUNT,
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_TYPE,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.CONFIDENCE_SCORE,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_TYPE,
    props.IS_RECOMMENDED,
    props.MAINTENANCE_MODE,
    props.IS_SIMILAR,
    props.MEMBERSHIP_NAME,
    props.SIMILAR_CARD
  ],
  [events.UNLOCK_APPLY_SIMILARITY_BUTTON_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.REQUIREMENT_COUNT,
    props.REQUIREMENT_TYPE,
    props.CONFIDENCE_SCORE,
    props.SCHOLARSHIP_EXPIRATION_DATE,
    props.APPLICATION_COUNT,
    props.SCHOLARSHIP_TYPE,
    props.IS_RECOMMENDED,
    props.MAINTENANCE_MODE,
    props.IS_SIMILAR,
    props.SIMILAR_CARD
  ],
  [events.UNLOCK_PRO_SIMILARITY_CLICK]: [
    props.PRO_MODAL_NEW,
    props.SIMILAR_CARD
  ],
  [events.UPGRADE_UNLOCK_BLURRED_BUTTON_CLICK]: [
    props.TAB_NAME,
    props.FREEMIUM_LIMITED,
    props.PRO_MODAL_NEW
  ],
  [events.APPLY_EXTERNALLY_BUTTON_CLICK]: [
    props.TAB_NAME,
    props.FREEMIUM_LIMITED,
    props.PRO_MODAL_NEW
  ],
  [events.UNLOCK_TO_APPLY_DIRECTLY_BUTTON_CLICK]: [
    props.TAB_NAME,
    props.FREEMIUM_LIMITED,
    props.PRO_MODAL_NEW
  ],
  [events.PRO_MODAL_CAROUSEL_CLICK]: [
    props.TAB_NAME,
    props.OPENED_FROM,
    props.IS_MEMBER,
    props.IS_MOBILE,
    props.PRO_MODAL_NEW,
    props.FREEMIUM_STATUSES
  ],
  [events.UNLOCK_CREDIBILITY_SCORES_BUTTON_CLICK]: [
    props.SCHOLARSHIP_ID,
    props.FREEMIUM_CREDIBILITY,
    props.CONFIDENCE_SCORE,
    props.CREDIBILITY_SCORE
  ],
  [events.UNLOCK_STATUSES_BUTTON_CLICK]: [
    props.PRO_MODAL_NEW,
    props.FREEMIUM_STATUSES
  ],
  [events.NO_THANKS_STATUS_BUTTON_CLICK]: [
    props.PRO_MODAL_NEW,
    props.FREEMIUM_STATUSES
  ],
  [events.FREEMIUM_PAYWALL_POPUP_OPEN]: [
    props.TAB_NAME,
    props.OPENED_FROM,
    props.IS_MEMBER,
    props.IS_MOBILE,
    props.FREEMIUM_EXIT_POPUP
  ],
  [events.FREEMIUM_PAYWALL_ACCEPT_OFFER_CTA_CLICK]: [
    props.TAB_NAME,
    props.OPENED_FROM,
    props.IS_MEMBER,
    props.IS_MOBILE,
    props.FREEMIUM_EXIT_POPUP
  ],
  [events.PROVIDER_SOCIAL_LINK_CLICK]: [
    props.SCHOLARSHIP_PROVIDER_NAME,
    props.SOCIAL_NETWORK_NAME,
    props.SCHOLARSHIP_ID,
    props.TAB_NAME
  ],
  [events.PROVIDER_MISSION_SHOW_MORE_CLICK]: [
    props.SCHOLARSHIP_PROVIDER_NAME,
    props.SCHOLARSHIP_ID,
    props.TAB_NAME
  ],
  [events.GUEST_GIFT_CTA_CLICKED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.GUEST_GIFT_POPUP_CLOSED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.GUEST_GIFT_LINK_COPIED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.TRIAL_EXTENSION_CTA_CLICKED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.TRIAL_EXTENSION_POPUP_OPENED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.TRIAL_EXTENSION_POPUP_CLOSED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.TRIAL_EXTENSION_LINK_COPIED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ],
  [events.TRIAL_EXTENSION_SUCCESS_POPUP_OPENED]: [
    props.TAB_NAME,
    props.IS_MOBILE
  ]
}
